// @ts-strict-ignore
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef } from 'react';
import isChromatic from 'chromatic/isChromatic';
import { Animated, Easing } from 'react-native';

export const AnimatedShakeView = ({
  children,
}) => {
  const animatedValue = useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 2.0, duration: 50, easing: Easing.linear, useNativeDriver: true,
        }),
        Animated.timing(animatedValue, {
          toValue: -2.0, duration: 100, easing: Easing.linear, useNativeDriver: true,
        }),
        // return to start position
        Animated.timing(animatedValue, {
          toValue: 0.0, duration: 50, easing: Easing.linear, useNativeDriver: true,
        }),
        Animated.timing(animatedValue, {
          toValue: 2.0, duration: 50, easing: Easing.linear, useNativeDriver: true,
        }),
        Animated.timing(animatedValue, {
          toValue: -2.0, duration: 100, easing: Easing.linear, useNativeDriver: true,
        }),
        // return to start position
        Animated.timing(animatedValue, {
          toValue: 0.0, duration: 50, easing: Easing.linear, useNativeDriver: true,
        }),
        // wait 5 seconds before next animation
        Animated.timing(animatedValue, {
          toValue: 0.0, duration: 5000, easing: Easing.linear, useNativeDriver: true,
        }),
      ]),
    );

    if (!isChromatic()) {
      animation.start(() => {});
    }
  }, [animatedValue]);

  return (
    <Animated.View style={{ transform: [{ translateX: animatedValue }] }}>
      {children}
    </Animated.View>
  );
};
